import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Layout from "./Layout/Layout.jsx";
import Home from "./pages/Home/Home.jsx";
import AGB from "./pages/AGB/AGB.jsx";
import Datenschutz from "./pages/Datenschutz/Datenschutz.jsx";
import Impressum from "./pages/Impressum/Impressum.jsx";
import Einwilligung from "./pages/Einwilligung/Einwilligung.jsx";
import ExternalLink from "./pages/ExternerLink/ExternalLink.jsx";
import Kontakt from "./pages/Kontaktformular/Kontakt.jsx";
import Locations from "./pages/Locations/Locations.jsx";
import PopupEinwilligung from "./components/Einwilligung/Pop-up Einwilligung.jsx";

function App() {
  return (
    <BrowserRouter>
      <PopupEinwilligung>
        <Routes>
          <Route
            path="/"
            element={
              <Layout>
                <Home />
              </Layout>
            }
          />
          <Route
            path="/kontakt"
            element={
              <Layout>
                <Kontakt />
              </Layout>
            }
          />
          <Route
            path="/locations"
            element={
              <Layout>
                <Locations />
              </Layout>
            }
          />
          <Route
            path="/agb"
            element={
              <Layout>
                <AGB />
              </Layout>
            }
          />
          <Route
            path="/datenschutzerklaerung"
            element={
              <Layout>
                <Datenschutz />
              </Layout>
            }
          />
          <Route
            path="/impressum"
            element={
              <Layout>
                <Impressum />
              </Layout>
            }
          />
          <Route
            path="/einwilligungen"
            element={
              <Layout>
                <Einwilligung />
              </Layout>
            }
          />
          <Route
            path="/extern"
            element={
              <Layout>
                <ExternalLink />
              </Layout>
            }
          />
          <Route
            path="/popup"
            element={
              <Layout>
                <PopupEinwilligung />
              </Layout>
            }
          />
        </Routes>
      </PopupEinwilligung>
    </BrowserRouter>
  );
}

export default App;
